export default __webpack_public_path__ + "static/media/channel_galaxy_img_02@2x.3d4faa50.png";